module.exports = __webpack_public_path__ + "static/media/011_Bitmap.72891957.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redbox/011_Bitmap.png
// module id = 604
// module chunks = 0